import { Clipboard } from '@angular/cdk/clipboard';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-bus-account-invitation-link-label',
  templateUrl: './bus-account-invitation-link-label.component.html',
  styleUrls: ['./bus-account-invitation-link-label.component.scss'],
})
export class BusAccountInvitationLinkLabelComponent
  implements OnInit, OnChanges
{
  @Input() id = 0;
  data: any;

  constructor(
    private api: ProductApiService,
    private clipboard: Clipboard,
    private message: MessageService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    this.getBusAccountInvitationLink();
  }

  async getBusAccountInvitationLink() {
    try {
      const r = await this.api.getBusAccountInvitationLink(this.id);
      this.data = r.data;
    } catch (error) {}
  }

  copy() {
    this.clipboard.copy(this.data?.url);
    this.message.open('邀请链接已复制');
  }
}
